<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="6">
                Locations
              </b-col>
              <b-col cols="6" class="text-right">
                <b-btn size="sm" v-if="$can('create', 'locations')" variant="success" @click="add"><i class="icon-plus mr-1"></i>Add</b-btn>
              </b-col>
            </b-row>
          </template>
          <loading :isLoading="isLoading" :items="locations" noItemsText="No Locations"></loading>
          <div class="animated fadeIn" v-if="!isLoading && locations.length > 0">
            <b-table class="table-outline" :hover="true" head-variant="light" responsive="sm" :items="locations" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
              <template slot="status" slot-scope="data">
                <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
              </template>
              <template v-slot:cell(address)="data">
                <address-text v-model="data.value"></address-text>
              </template>
              <template v-slot:cell(numbers)="data">
                <b-badge size="md" v-for="number in data.value" v-bind:key="number.id">
                  <phone-number v-model="number.number"></phone-number>
                </b-badge>
              </template>
              <template v-slot:cell(status)="data">
                <b-badge variant="success" v-if="data.item.default">Default</b-badge>
                <b-badge variant="primary" v-if="data.item.e911">e911</b-badge>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(locations)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <add-location-modal @add="addLocation" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddressText from '@/components/text/AddressText'
import Loading from '@/components/text/Loading'
import PhoneNumber from '@/components/text/PhoneNumber'
import AddLocationModal from './partials/AddLocation'

export default {
  name: 'locations',
  components: {
    AddLocationModal,
    AddressText,
    Loading,
    PhoneNumber
  },
  computed: {
    ...mapGetters({
      account: 'global/account',
      locations: 'account/locations',
    })
  },
  data () {
    return {
      caption: 'Locations',
      isLoading: false,
      hover: true,
      striped: true,
      bordered: false,
      small: false,
      fixed: false,
      fields: [
        {key: 'name'},
        {key: 'address', label: 'Address'},
        {key: 'numbers', label: 'Associated Numbers'},
        {key: 'status', label: '', class: 'text-right'}
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0
    }
  },
  methods: {
    add () {
      this.$bus.$emit('modal:addLocation')
    },
    addLocation (location) {
      const locationLink = this.locationLink(location.id)
      this.$router.push({path: locationLink})
      this.$store.dispatch('account/getLocations')
    },
    numberLink (id) {
      return `locations/${id.toString()}`
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    locationLink (id) {
      return `locations/${id.toString()}`
    },
    rowClicked (item) {
      const locationLink = this.locationLink(item.id)
      this.$router.push({path: locationLink})
    }
  },
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.badge {
  margin-right: 4px;
}
.badge:last-child {
  margin-right: 0px;
}
</style>
